//frontend/src/components/AdminRequests/Chat/components/MessageList.jsx

import React, { useEffect, useMemo, useRef } from "react";
import MessageBubble from "./MessageBubble";

export default function MessageList({
  events,
  meId,
  accessToken,
  profiles,
  onLoadMore,
  hasMore,
  loadingMore,
  onReply,
  onReact,
}) {
  const bottomRef = useRef(null);
  const listRef = useRef(null);
  const wasAtBottomRef = useRef(true);

  const isAtBottom = () => {
    const el = listRef.current;
    if (!el) return false;
    return el.scrollHeight - el.scrollTop - el.clientHeight < 100;
  };

  // Автоскролл вниз ТОЛЬКО если пользователь уже был внизу.
  // Иначе новые сообщения не будут мешать читать историю.
  useEffect(() => {
    if (wasAtBottomRef.current && bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [events.length]);

  const reactionsByTarget = useMemo(() => {
    const map = {};
    for (const ev of events) {
      if (ev.type !== "m.reaction") continue;
      const rel = ev.content?.["m.relates_to"];
      if (!rel || rel.rel_type !== "m.annotation") continue;
      const target = rel.event_id;
      const key = rel.key;
      if (!target || !key) continue;
      map[target] = map[target] || {};
      map[target][key] = map[target][key] || {
        key,
        count: 0,
        senders: new Set(),
      };
      map[target][key].count += 1;
      map[target][key].senders.add(ev.sender);
    }
    return map;
  }, [events]);

  const eventById = useMemo(() => {
    const m = {};
    for (const ev of events) m[ev.event_id] = ev;
    return m;
  }, [events]);

  const handleScroll = () => {
    wasAtBottomRef.current = isAtBottom();
    if (!listRef.current) return;
    if (listRef.current.scrollTop < 60 && hasMore && !loadingMore) {
      onLoadMore?.();
    }
  };

  return (
    <div className="chat-messages" ref={listRef} onScroll={handleScroll}>
      {loadingMore && (
        <div className="chat-messages__more">Загрузка истории…</div>
      )}

      {events.map((ev) => {
        if (ev.type !== "m.room.message" && ev.type !== "m.reaction") {
          return null;
        }
        if (ev.type === "m.reaction") return null;

        const isMine = ev.sender === meId;
        const profile = profiles[ev.sender] || {};
        const senderName =
          profile.displayname ||
          ev.sender.split(":")[0].replace("@", "");

        const replyEventId =
          ev.content?.["m.relates_to"]?.["m.in_reply_to"]?.event_id;
        const repliedEv = replyEventId ? eventById[replyEventId] : null;

        const repliedTo = repliedEv
          ? {
              senderName:
                profiles[repliedEv.sender]?.displayname ||
                repliedEv.sender.split(":")[0].replace("@", ""),
              preview:
                repliedEv.content?.body?.slice(0, 120) || "(вложение)",
            }
          : null;

        const reactions = Object.values(
          reactionsByTarget[ev.event_id] || {}
        ).map((r) => ({ key: r.key, count: r.count }));

        return (
          <MessageBubble
            key={ev.event_id}
            event={ev}
            isMine={isMine}
            accessToken={accessToken}
            senderName={senderName}
            senderAvatar={profile.avatar_url ? profile.avatar_url : null}
            reactions={reactions}
            repliedTo={repliedTo}
            onReply={onReply}
            onReact={onReact}
          />
        );
      })}

      <div ref={bottomRef} />
    </div>
  );
}